export const transformSearchTranslations = searchTranslations => {
  var _searchTranslations$n, _searchTranslations$n2;

  if (!searchTranslations) return undefined;
  return {
    placeholder: searchTranslations.placeholder,
    noResults: {
      title: (_searchTranslations$n = searchTranslations.no_results) === null || _searchTranslations$n === void 0 ? void 0 : _searchTranslations$n.title,
      body: (_searchTranslations$n2 = searchTranslations.no_results) === null || _searchTranslations$n2 === void 0 ? void 0 : _searchTranslations$n2.body
    }
  };
};
export const transformDynamicFilterOptions = dynamicFilterOptions => {
  if (!(dynamicFilterOptions !== null && dynamicFilterOptions !== void 0 && dynamicFilterOptions.length)) return [];
  return dynamicFilterOptions.map(_ref => {
    let {
      id,
      title,
      description,
      type,
      prefix,
      items_count,
      items_count_max,
      options
    } = _ref;
    return {
      id,
      title,
      description,
      type,
      prefix,
      itemsCount: items_count,
      itemsCountMax: items_count_max,
      options: transformDynamicFilterOptions(options)
    };
  });
};
export const transformDynamicFilter = _ref2 => {
  let {
    id,
    title,
    code,
    display_type,
    selection_type,
    is_selection_highlighted,
    search_translations,
    is_new_filter,
    options
  } = _ref2;
  return {
    id,
    title,
    type: code,
    displayType: display_type,
    selectionType: selection_type,
    isSelectionHighlighted: is_selection_highlighted,
    searchTranslations: transformSearchTranslations(search_translations),
    isNewFilter: is_new_filter,
    options: transformDynamicFilterOptions(options)
  };
};
export const transformDynamicFilters = dynamicFilters => dynamicFilters.map(transformDynamicFilter);
export const transformSelectedDynamicFilter = _ref3 => {
  let {
    code,
    ids
  } = _ref3;
  return {
    type: code,
    ids
  };
};
export const transformSelectedDynamicFilters = selectedFilters => selectedFilters.map(transformSelectedDynamicFilter);
export const transformSelectedDefaultDynamicFilters = selectedDefaultFilters => selectedDefaultFilters.map(transformSelectedDynamicFilter);